import React from 'react';

/** A catalog icon: a BUNDLED Noto Color Emoji image, never the device's emoji font.
 *  `badge` renders at 40% of the tile, bottom-right, exactly as in the Atlas. */
export const GroceryIcon = ({ icon, badge, alt = '', size = 44, testId }) => (
    <span
        className="relative inline-block shrink-0 select-none"
        style={{ width: size, height: size }}
        data-testid={testId}
    >
        <img
            src={icon}
            alt={alt}
            width={size}
            height={size}
            loading="eager"
            decoding="async"
            draggable={false}
            className="w-full h-full object-contain"
            data-grocery-icon={icon || 'none'}
        />
        {badge ? (
            <img
                src={badge}
                alt=""
                aria-hidden="true"
                loading="eager"
                decoding="async"
                draggable={false}
                className="absolute object-contain drop-shadow"
                style={{ width: size * 0.4, height: size * 0.4, right: -2, bottom: -2 }}
                data-grocery-badge={badge}
            />
        ) : null}
    </span>
);

export default GroceryIcon;
